import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.tsx';
import { startOfflineSupport } from './lib/bootstrap.ts';
import { I18nProvider } from './lib/i18n.tsx';
import './index.css';

const container = document.querySelector('#root');

if (container === null) {
  throw new Error('index.html is missing its #root element');
}

createRoot(container).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);

// After the first paint, never before it. Nobody standing at a forklift should wait
// on a database handle.
void startOfflineSupport();
